document.addEventListener('DOMContentLoaded', () => {

    // Ég hef samræmt gagnaskipulagið og bætt við nýjum prógrömmum hér
    const allContent = [
        // BYRJENDAPRÓGRÖM
        {
            id: 'byrjendur-2-daga', contentType: 'program', tags: ['byrjandi', 'styrkur'], durationDays: 2,
            title: '2 Daga Prógram (Byrjendur)',
            description: 'Tveir lyftingardagar með fókus á allan líkamann á báðum dögunum.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/BackToGymSWEATf1f07a7f6f79e7b8807d2436a6ae8e8b.jpg?v=1752255439',
            dailyPlan: [
                { day: 1, title: 'Dagur 1', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hnébeygjur', details: '3x8-10' },
                    { name: 'Mjaðmalyftur', details: '3x8-10 (mæli með að nota teygju og lóð ef þú treystir þér til)' },
                    { name: 'Réttstöðulyfta með ketilbjöllu', details: '2x8-10' },
                    { name: 'Kálfalyftur', details: '3x10' },
                    { name: 'Axlapressa', details: '2x8-10' },
                    { name: 'Þríhöfðalyfta yfir höfuð', details: '2x8-10' },
                    { name: 'Gólfpressa', details: '2x8-10' },
                    { name: 'Bakfettur', details: '2x15' },
                    { name: 'Planki', details: '2x20sek, eða lengur ef þú getur' }
                ] }] },
                { day: 2, title: 'Dagur 2', sections: [{ title: 'Æfingar', items: [
                    { name: 'Framstig', details: '3x8 á fót' },
                    { name: 'Mjaðmalyftur', details: '3x8-10 (mæli með að nota teygju og lóð ef þú treystir þér til)' },
                    { name: 'Kickbacks við vegg með teygju um ökkla', details: '3x8 á fót' },
                    { name: 'Kálfalyftur', details: '3x10' },
                    { name: 'Niðurtog', details: '2x8-10' },
                    { name: 'Róður á bekk', details: '2x8-10 á hendi' },
                    { name: 'Tvíhöfðalyfta', details: '2x8-10' },
                    { name: 'Planki', details: '2x20sek, eða lengur ef þú getur' },
                    { name: 'Magaæfingar að eigin vali', details: '2x10-12' }
                ] }] }
            ]
        },
        {
            id: 'byrjendur-3-daga', contentType: 'program', tags: ['byrjandi', 'styrkur'], durationDays: 3,
            title: '3 Daga Prógram (Byrjendur)',
            description: 'Skipt í neðri líkama, efri líkama og svo allan líkamann.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/istockphoto-940552590-612x612.jpg?v=1751762159',
            dailyPlan: [
                { day: 1, title: 'Dagur 1 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hnébeygjur', details: '3x8' }, { name: 'Mjaðmalyftur', details: '3x10' },
                    { name: 'Kickbacks við vegg með teygju um ökkla', details: '3x8 á fót' },
                    { name: 'Afturstig', details: '2x8 á fót' }, { name: 'Hamstring curl', details: '2x8-10 á fót' },
                    { name: 'Knee extensions', details: '2x8-10 á fót' }
                ] }] },
                { day: 2, title: 'Dagur 2 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Niðurtog', details: '3x8' }, { name: 'Face Pulls', details: '2x8-10' },
                    { name: 'Bicep Curls', details: '2x8' }, { name: 'Hammer curls', details: '2x8' },
                    { name: 'Þríhöfðapressa', details: '3x8-10' }, { name: 'Axlapressa', details: '3x8-10' },
                    { name: 'Lateral raises', details: '2x8-10' }, { name: 'Róður', details: '3x8 á hendi' }
                ] }] },
                { day: 3, title: 'Dagur 3 - Allur líkaminn', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hnébeygjur', details: '3x8' }, { name: 'Réttstöðulyfta', details: '2x8' },
                    { name: 'Kálfalyftur', details: '2x10' }, { name: 'Hamstring curl', details: '2x10 á fót' },
                    { name: 'Róður í planka stöðu', details: '2x10 (má vera á hnjám)' },
                    { name: 'Bicep curls', details: '3x8' }, { name: 'Gólfpressa', details: '3x8' },
                    { name: 'Kviðkreppur', details: '3x10' }, { name: 'Bakfettur', details: '3x10' }
                ] }] }
            ]
        },
        {
            id: 'byrjendur-4-daga', contentType: 'program', tags: ['byrjandi', 'styrkur'], durationDays: 4,
            title: '4 Daga Prógram (Byrjendur)',
            description: 'Skipt í tvo efri líkama og tvo neðri líkama daga.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Woman-with-Weights.jpg?v=1752325260',
            dailyPlan: [
                { day: 1, title: 'Dagur 1 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Goblet squat', details: '3x10-12' }, { name: 'Mjaðmalyftur á gólfi', details: '3x12-25' },
                    { name: 'Step ups', details: '3x8-10 á fót' }, { name: 'RDL', details: '3x10' },
                    { name: 'Kickbacks', details: '' }, { name: 'Wall sit hold', details: '2x30-45 sek' }
                ] }] },
                { day: 2, title: 'Dagur 2 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Gólfpressa', details: '3x10-12' }, { name: 'Axlapressa', details: '3x10-12' },
                    { name: 'Lateral raises', details: '3x10-12' }, { name: 'Overhead þríhöfðalyfta', details: '3x10' },
                    { name: 'Dýfur á bekk', details: '3x8-10' }, { name: 'Planki halda', details: '2x30 sek' }
                ] }] },
                { day: 3, title: 'Dagur 3 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '3x10-12' }, { name: 'Afturstig', details: '3x8 á fót' },
                    { name: 'Ketilbjöllusveiflur', details: '3x10-12' }, { name: 'Kickbacks', details: '3x10-12 á fót' },
                    { name: 'Kálfalyftur', details: '3x20' }
                ] }] },
                { day: 4, title: 'Dagur 4 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Niðurtog', details: '3x10' }, { name: 'Róður á bekk', details: '3x10 á hendi' },
                    { name: 'Bicep curls', details: '3x10-12' }, { name: 'Hammer curls', details: '3x10-12' },
                    { name: 'Facepulls', details: '3x12-15' }, { name: 'Dead bugs', details: '3x12-14' },
                    { name: 'Planki halda', details: '2x30sek' }
                ] }] }
            ]
        },
        // PRÓGRÖM FYRIR LENGRA KOMNA
        {
            id: 'lengra-komnir-2-daga', contentType: 'program', tags: ['styrkur', 'lengra-komnir'], durationDays: 2,
            title: '2 Daga Prógram (Lengra komnir)',
            description: 'Tveir "full body" dagar með fókus á styrk fyrir lengra komna.',
            imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
            dailyPlan: [
                { day: 1, title: 'Dagur 1', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hipthrust', details: '4x8-10' }, { name: 'RDLS', details: '3x8-10' },
                    { name: 'Step ups', details: '3x8-10 á fót (í cable á boxi)' },
                    { name: 'Hamstring curl', details: '3x10 á fót' }, { name: 'Kálfar (með þyngd)', details: '3x12' },
                    { name: 'Niðurtog', details: '3x10' }, { name: 'Róður (single arm)', details: '3x8-10 á hendi' },
                    { name: 'Bicep curl', details: '3x10' }, { name: 'Hammer Curls', details: '3x10' }
                ] }] },
                { day: 2, title: 'Dagur 2', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hnébeygja', details: '4x8-10' }, { name: 'Narrow stance squat í vél', details: '3x8-10' },
                    { name: 'Knee extensions', details: '3x10 á fót' }, { name: 'Bulgarian split squats', details: '3x8 á fót' },
                    { name: 'Axlapressa', details: '3x8-10' }, { name: 'Lateral raises', details: '3x8' },
                    { name: 'OH tricep extension', details: '3x8-10' }, { name: 'Cable tricep pushdown', details: '3x10' }
                ] }] }
            ]
        },
        {
            id: 'lengra-komnir-3-daga', contentType: 'program', tags: ['styrkur', 'lengra-komnir'], durationDays: 3,
            title: '3 Daga Prógram (Lengra komnir)',
            description: 'Skipt í efri líkama, neðri líkama og "full body" fyrir lengra komna.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Woman-with-Weights.jpg?v=1752325260',
            dailyPlan: [
                { day: 1, title: 'Dagur 1 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '4x8-10' }, { name: 'RDL', details: '3x8-10' },
                    { name: 'Step ups', details: '4x8-10 á fót (í cable á boxi)' },
                    { name: 'Hamstring curl', details: '3x10 á fót' }, { name: 'Kickbacks', details: '3x10 á fót' },
                    { name: 'Kálfar (með þyngd)', details: '3x12' }
                ] }] },
                { day: 2, title: 'Dagur 2 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Niðurtog', details: '3x8-10' }, { name: 'Axlapressa', details: '3x8-10' },
                    { name: 'Lateral raises', details: '3x8' }, { name: 'Chest Press í tæki', details: '3x8-10' },
                    { name: 'Tricep pushdown', details: '3x10' }, { name: 'Overhead tricep extensions', details: '3x8-10' },
                    { name: 'Bicep curls', details: '3x10' }
                ] }] },
                { day: 3, title: 'Dagur 3 - Allur líkaminn', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hnébeygjur', details: '4x8-10' }, { name: 'Narrow stance hnébeygja í tæki', details: '3x8-10' },
                    { name: 'Knee extensions', details: '3x10 á fót' }, { name: 'Kickbacks í cable', details: '3x8-12 á fót' },
                    { name: 'Seated rows (vél/cable)', details: '4x8-10' }, { name: 'Bicep curls', details: '3x10' },
                    { name: 'Axlapressa', details: '3x8-10' }, { name: 'Tricep pushdowns', details: '3x10' }
                ] }] }
            ]
        },
        {
            id: 'lengra-komnir-4-daga', contentType: 'program', tags: ['styrkur', 'lengra-komnir'], durationDays: 4,
            title: '4 Daga Prógram (Lengra komnir)',
            description: 'Tveir efri líkama og tveir neðri líkama dagar fyrir lengra komna.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/istockphoto-940552590-612x612.jpg?v=1751762159',
            dailyPlan: [
                { day: 1, title: 'Dagur 1 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '4x8-10' }, { name: 'Single leg RDL', details: '3x8-10 á fót' },
                    { name: 'Step ups í cable', details: '3x8-10 á fót' }, { name: 'Hamstring curl', details: '3x10 á fót' },
                    { name: 'Kickbacks í cable', details: '3x10 á fót' }, { name: 'Kálfar með þyngd', details: '3x12' }
                ] }] },
                { day: 2, title: 'Dagur 2 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Niðurtog', details: '4x8-10' }, { name: 'Bent over row', details: '3x8-10' },
                    { name: 'Seated single arm row', details: '3x8-10 á hendi' }, { name: 'Bicep curls', details: '4x8-10' },
                    { name: 'Hammer curls', details: '3x8-10' }
                ] }] },
                { day: 3, title: 'Dagur 3 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '4x8-10' }, { name: 'RDLS', details: '4x8-10' },
                    { name: 'Narrow Stance hnébeygja í tæki', details: '3x8-10' },
                    { name: 'Upphækkað goblet squat', details: '3x8-10' }, { name: 'Knee extensions', details: '3x10 á fót' },
                    { name: 'Kickbacks í cable', details: '3x10 á fót' }
                ] }] },
                { day: 4, title: 'Dagur 4 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Axlapressa', details: '4x8-10' }, { name: 'Lateral raises', details: '3x8-10' },
                    { name: 'Chestpress í tæki', details: '4x8-10 (má líka taka bekkpressu)' },
                    { name: 'Overhead tricep extensions', details: '3x8-10' },
                    { name: 'Tricep pushdowns í cable', details: '3x10' }
                ] }] }
            ]
        },
        {
            id: 'lengra-komnir-5-daga', contentType: 'program', tags: ['styrkur', 'lengra-komnir'], durationDays: 5,
            title: '5 Daga Prógram (Lengra komnir)',
            description: 'Tveir efri, tveir neðri og einn "full body" dagur fyrir hámarksárangur.',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/BackToGymSWEATf1f07a7f6f79e7b8807d2436a6ae8e8b.jpg?v=1752255439',
            dailyPlan: [
                { day: 1, title: 'Dagur 1 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '4x8-10' }, { name: 'Single leg RDL', details: '3x8-10 á fót' },
                    { name: 'Step ups í cable', details: '3x8-10 á fót' }, { name: 'Hamstring curl', details: '3x10 á fót' },
                    { name: 'Kickbacks í cable', details: '3x10 á fót' }, { name: 'Kálfar með þyngd', details: '3x12' }
                ] }] },
                { day: 2, title: 'Dagur 2 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Niðurtog', details: '4x8-10' }, { name: 'Bent over row', details: '3x8-10' },
                    { name: 'Seated single arm row', details: '3x8-10 á hendi' }, { name: 'Bicep curls', details: '4x8-10' },
                    { name: 'Hammer curls', details: '3x8-10' }
                ] }] },
                { day: 3, title: 'Dagur 3 - Neðri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Hip thrust', details: '4x8-10' }, { name: 'RDLS', details: '4x8-10' },
                    { name: 'Narrow Stance hnébeygja í tæki', details: '3x8-10' },
                    { name: 'Upphækkað goblet squat', details: '3x8-10' }, { name: 'Knee extensions', details: '3x10 á fót' },
                    { name: 'Kickbacks í cable', details: '3x10 á fót' }
                ] }] },
                { day: 4, title: 'Dagur 4 - Efri líkami', sections: [{ title: 'Æfingar', items: [
                    { name: 'Axlapressa', details: '4x8-10' }, { name: 'Lateral raises', details: '3x8-10' },
                    { name: 'Chestpress í tæki', details: '4x8-10 (má líka taka bekkpressu)' },
                    { name: 'Overhead tricep extensions', details: '3x8-10' }, { name: 'Tricep pushdowns í cable', details: '3x10' }
                ] }] },
                { day: 5, title: 'Dagur 5 - Allur líkaminn', sections: [{ title: 'Æfingar', items: [
                    { name: 'Deadlift', details: '4x8-10' }, { name: 'Bulgarian split squats', details: '3x8 á fót' },
                    { name: 'Hnébeygja í tæki', details: '3x8-10' }, { name: 'Kálfar', details: '3x12' },
                    { name: 'Niðurtog', details: '4x8-10' }, { name: 'Single arm róður', details: '3x8-10 á hendi' },
                    { name: 'Upphýfingar', details: '3x6-8 (má nota teygju)' }
                ] }] }
            ]
        },
        // HEIMAÆFINGAR
        { id: 'heima-1', contentType: 'program', tags: ['heima'], durationMinutes: 30, title: 'Heimaæfing 1: Allur líkaminn', description: 'Góð grunnæfing fyrir allan líkamann.', imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/dumbbell-home-workout-scaled.webp?v=1752325115', exercises: [{name:'Hnébeygjur',sets:'3',reps:'10'}, {name:'Afturstig',sets:'3',reps:'8-10 á fót'}, {name:'Mjaðmalyftur',sets:'3',reps:'12-15'}, {name:'Axlapressa',sets:'3',reps:'10-12'}, {name:'Tvíhöfðalyftur',sets:'3',reps:'10'}, {name:'Armbeygjur',sets:'3',reps:'6-8 (á hnjám)'}] },
        { id: 'heima-2', contentType: 'program', tags: ['heima'], durationMinutes: 25, title: 'Heimaæfing 2: Allur líkaminn + Cardio', description: 'Hringæfing til að koma púlsinum vel upp.', imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/https___images.ctfassets.net_6np2whvu93rb_2wh3yVZ1hoatmokwJ1EwFt_b7323889951513337a4e6163b5d73cc4_GettyImages-1401067175.avif?v=1752185976', exercises: [{name:'Hnébeygja með axlapressu',sets:'3',reps:'10'}, {name:'Mountain climbers',sets:'3',reps:'20'}, {name:'Glute bridge hold með þríhöfðaréttum',sets:'3',reps:'10'}, {name:'Afturstig með hnélyftu',sets:'3',reps:'8 á fót'}, {name:'Planki með shoulder tabs',sets:'3',reps:'20'}] },
        { id: 'heima-3', contentType: 'program', tags: ['heima', 'styrkur'], durationMinutes: 20, title: 'Heimaæfing 3: Kviður & Rass', description: 'Þrír hringir af kvið- og rassæfingum.', imageUrl: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1626&q=80', exercises: [{name:'Kviðkreppur',sets:'3 hringir',reps:'15'}, {name:'Dead bugs',sets:'',reps:'20'}, {name:'Mjaðmalyftur',sets:'',reps:'20'}, {name:'Glute bridge hold',sets:'',reps:'30 sek'}, {name:'Planki',sets:'',reps:'30 sek'}] },
        { id: 'heima-4', contentType: 'program', tags: ['heima'], durationMinutes: 25, title: 'Heimaæfing 4: Neðri líkami', description: 'Fókus á fætur og rass.', imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Weekly-At-Home-Workout-Plan.webp?v=1753129685', exercises: [{name:'Hnébeygjur',sets:'3',reps:'10'}, {name:'RDL',sets:'3',reps:'10-12'}, {name:'Mjaðmalyftur',sets:'3',reps:'12-15'}, {name:'Halda í hnébeygju við vegg',sets:'3',reps:'30-45 sek'}, {name:'Afturstig með hnélyftu',sets:'3',reps:'8 á fót'}] },
        { id: 'heima-5', contentType: 'program', tags: ['heima', 'styrkur'], durationMinutes: 25, title: 'Heimaæfing 5: Efri líkami', description: 'Einblínt á styrk í efri hluta líkamans.', imageUrl: 'https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80', exercises: [{name:'Gólfpressa',sets:'3',reps:'10-12'}, {name:'Axlapressa',sets:'3',reps:'10-12'}, {name:'Þríhöfðalyfta yfir haus',sets:'3',reps:'10-12'}, {name:'Armbeygjur',sets:'3',reps:'8 (á hnjám)'}, {name:'Tvíhöfðalyfta',sets:'3',reps:'10-12'}, {name:'Hammer curl',sets:'3',reps:'10-12'}] },
        { id: 'heima-6', contentType: 'program', tags: ['heima'], durationMinutes: 20, title: 'Heimaæfing 6: FullBody með cardio', description: 'Sprengikraftsæfing fyrir allan líkamann.', imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80', exercises: [{name:'Hnébeygjuhopp',sets:'3',reps:'12'}, {name:'Mountain climbers',sets:'3',reps:'20'}, {name:'Afturstig dúa hægri',sets:'3',reps:'12'}, {name:'Afturstig dúa vinstri',sets:'3',reps:'12'}, {name:'Tvíhöfðalyfta',sets:'3',reps:'12'}] }
    ];
    
    const hubNav = document.querySelector('.hub-nav');
    const programsView = document.getElementById('programs-view');
    const videosView = document.getElementById('videos-view');
    const programsGrid = document.getElementById('programs-grid-container');
    const programsFilters = document.getElementById('programs-filters');
    const modalOverlay = document.getElementById('content-modal-overlay');
    const modalContentBody = document.getElementById('modal-content-body');
    const modalCloseButton = modalOverlay.querySelector('.modal-close-button');

    function displayPrograms() {
        const activeProgramFilter = programsFilters.querySelector('.active').dataset.filter;
        const filteredPrograms = allContent.filter(item => item.contentType === 'program' && (activeProgramFilter === 'all' || item.tags.includes(activeProgramFilter)));
        programsGrid.innerHTML = filteredPrograms.map(item => renderCard(item)).join('');
    }
    
    function renderCard(item) {
        const iconClass = 'fa-clipboard-list';
        let metaHtml = '';
        if (item.durationDays) { metaHtml += `<span class="meta-item"><i class="fas fa-calendar-day"></i> ${item.durationDays} dagar</span>`; }
        if (item.durationMinutes) { metaHtml += `<span class="meta-item"><i class="fas fa-clock"></i> ${item.durationMinutes} mín</span>`; }
        if (item.tags.includes('byrjandi')) { metaHtml += `<span class="meta-item"><i class="fas fa-user-graduate"></i> Byrjandi</span>`; }
        if (item.tags.includes('lengra-komnir')) { metaHtml += `<span class="meta-item"><i class="fas fa-dumbbell"></i> Lengra komnir</span>`; }
        
        return `
            <div class="content-card" data-id="${item.id}">
                <div class="content-thumbnail" style="background-image: url('${item.imageUrl}');">
                    <i class="fas ${iconClass} content-type-icon"></i>
                </div>
                <div class="content-card-body">
                    <h3>${item.title}</h3>
                    <div class="content-card-meta">${metaHtml}</div>
                    <p>${item.description}</p>
                    <button class="btn-go">Skoða</button>
                </div>
            </div>`;
    }

    function openModal(itemId) {
        const item = allContent.find(c => c.id === itemId);
        if (!item) return;
        
        let modalHtml = '';
        if (item.dailyPlan) { 
            const dayTabs = item.dailyPlan.map((day, i) => `<button class="program-tab-btn ${i === 0 ? 'active' : ''}" data-day="${day.day}">Dagur ${day.day}</button>`).join('');
            const dayContents = item.dailyPlan.map((day, i) => `
                <div class="program-day-content ${i === 0 ? 'active' : ''}" data-day-content="${day.day}">
                    <h3>${day.title}</h3>
                    ${day.sections.map(sec => `
                        <div class="day-section">
                            <h4 class="section-title">${sec.title}</h4>
                            ${sec.items.map(exercise => `
                                <div class="exercise-item-detailed">
                                    <span class="exercise-name">${exercise.name}</span>
                                    <span class="exercise-sets-reps">${exercise.details}</span>
                                </div>
                            `).join('')}
                        </div>
                    `).join('')}
                </div>
            `).join('');

            modalHtml = `
                <div class="modal-header-info"><h2>${item.title}</h2><p>${item.description}</p></div>
                <div class="program-tabs">${dayTabs}</div>
                <div class="program-content">${dayContents}</div>`;

        } else if (item.exercises) {
            const exerciseList = item.exercises.map(ex => `
                <div class="exercise-item-detailed">
                    <span class="exercise-name">${ex.name}</span>
                    <span class="exercise-sets-reps">
                        ${ex.sets && `<strong>${ex.sets}</strong>` }
                        ${ex.sets && ex.reps && ` x `}
                        ${ex.reps && `<strong>${ex.reps}</strong>`}
                    </span>
                </div>
            `).join('');

            modalHtml = `
                <div class="modal-header-info"><h2>${item.title}</h2><p>${item.description}</p></div>
                <div class="program-content">
                    <div class="day-section">
                        <h4 class="section-title">Æfingar</h4>
                        ${exerciseList}
                    </div>
                </div>`;
        }
        
        modalContentBody.innerHTML = modalHtml;
        modalOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        const programTabs = modalContentBody.querySelector('.program-tabs');
        if (programTabs) {
            programTabs.addEventListener('click', e => {
                if (e.target.tagName === 'BUTTON') {
                    const day = e.target.dataset.day;
                    programTabs.querySelector('.active').classList.remove('active');
                    e.target.classList.add('active');
                    modalContentBody.querySelectorAll('.program-day-content').forEach(content => {
                        content.classList.remove('active');
                        if (content.dataset.dayContent === day) content.classList.add('active');
                    });
                }
            });
        }
    }
    
    function closeModal() {
        modalContentBody.innerHTML = '';
        modalOverlay.style.display = 'none';
        document.body.style.overflow = 'auto';
    }

    hubNav.addEventListener('click', e => {
        if (e.target.classList.contains('hub-nav-btn')) {
            const view = e.target.dataset.view;
            hubNav.querySelector('.active').classList.remove('active');
            e.target.classList.add('active');
            document.querySelector('.hub-tab-content.active').classList.remove('active');
            document.getElementById(`${view}-view`).classList.add('active');
        }
    });

    programsFilters.addEventListener('click', e => {
        if (e.target.tagName === 'BUTTON') {
            programsFilters.querySelector('.active').classList.remove('active');
            e.target.classList.add('active');
            displayPrograms();
        }
    });
    
    document.body.addEventListener('click', e => {
        const card = e.target.closest('.content-card');
        if (card) {
            openModal(card.dataset.id);
        }
    });

    modalCloseButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', e => { if (e.target === modalOverlay) closeModal(); });

    // Upphafsköllun
    displayPrograms();
});